import React, {
	Component
} from 'react';
import styled from 'styled-components';

const ExitPage = styled.div`
	padding-top: ${p =>  0}%;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: ${p => 100}%;
	height: 100%;
	padding-top: 0%;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

export class ModalDimPanel extends Component {

	render() {

		return (
			<ExitPage>
				<Content>


				</Content>
			</ExitPage>
		);
	}
}